import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';

function getLocalizedStrings(locale, json) {
    locale || (locale = 'en-GB');
    if (json[locale])
        return json[locale];
    const shortLocale = locale.split('-')[0];
    if (json[shortLocale])
        return json[shortLocale];
    // find the first locale that matches the fallback locale, e.g. this would
    // choose `fr-CA` if we're given `fr-FR`, and `fr-CA` is present but `fr-FR`
    // is missing.
    const fallbackLocale = Object.keys(json).find(key => key.split('-')[0] === shortLocale);
    if (json[fallbackLocale])
        return json[fallbackLocale];
    return json['en-GB'] || json['en'];
}
function isAlphabeticKey(key) {
    return key.length === 1 && key.match(/[a-z]/i);
}
function injectFont(fontSrc = 'https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700&display=swap') {
    // Inject font link into the head
    // Taken from https://dev.to/akdevcraft/use-font-in-web-component-51a4
    // Using Jersey 15 font can be useful for debugging font loading as it is easier to see
    // When changing the font, make sure to update the font-family in `styles.scss`
    // const fontSrc = 'https://fonts.googleapis.com/css2?family=Jersey+15&display=swap';
    // Try to avoid adding the same link multiple times
    if (document.head.querySelector(`link[href="${fontSrc}"]`)) {
        return;
    }
    const font = document.createElement('link');
    font.href = fontSrc;
    font.rel = 'stylesheet';
    document.head.appendChild(font);
}

const rpfDropdownStrings = {
	"ar-SA": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"ca-ES": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"cs-CZ": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"cy-GB": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"da-DK": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"de-DE": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"el-GR": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"en-GB": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"es-ES": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"es-LA": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"et-EE": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"fi-FI": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"fr-CA": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"fr-FR": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"gu-IN": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"he-IL": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"hi-IN": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"hr-HR": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"hu-HU": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"it-IT": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"ja-JP": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"kn-IN": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"ko-KR": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"lt-LT": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"lv-LV": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"me-ME": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"mr-IN": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"ms-MY": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"nl-NL": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"no-NO": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"pl-PL": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"pt-BR": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"pt-PT": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"ro-RO": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"ru-RU": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"sk-SK": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"sl-SI": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"sr-SP": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"sv-SE": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"tr-TR": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"uk-UA": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"vls-BE": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"xh-ZA": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"zh-CN": {
	toggle_menu_title: "Toggle dropdown menu"
},
	"zh-TW": {
	toggle_menu_title: "Toggle dropdown menu"
}
};

const rpfDropdownCss = ":root, :host {\n  --rpf-white: hsla(0, 0%, 100%, 1);\n  --rpf-off-white: hsla(225, 25%, 97%, 1);\n  --rpf-grey-50: hsla(210, 8%, 95%, 1);\n  --rpf-grey-100: hsla(228, 10%, 90%, 1);\n  --rpf-grey-150: hsla(223, 9%, 85%, 1);\n  --rpf-grey-200: hsla(228, 10%, 80%, 1);\n  --rpf-grey-300: hsla(229, 9%, 75%, 1);\n  --rpf-grey-400: hsla(229, 8%, 61%, 1);\n  --rpf-grey-500: hsla(229, 9%, 42%, 1);\n  --rpf-grey-600: hsla(228, 9%, 32%, 1);\n  --rpf-grey-700: hsla(228, 9%, 22%, 1);\n  --rpf-grey-800: hsla(232, 9%, 18%, 1);\n  --rpf-grey-850: hsla(228, 9%, 15%, 1);\n  --rpf-grey-900: hsla(228, 9%, 10%, 1);\n  --rpf-grey-950: hsla(228, 8%, 5%, 1);\n  --rpf-black: hsla(0, 0%, 0%, 1);\n}\n\n:root, :host {\n  --border-radius: var(--space-1);\n  --border-radius-sm: var(--space-0-5);\n  --border-width-sm: 1px;\n  --border-width-md: 2px;\n  --border-width-lg: 3px;\n  --alert-border-width: var(--border-width-md);\n  --fieldset-border-width: var(--border-width-md);\n  --input-border-width: var(--border-width-md);\n  --table-border-width: var(--border-width-sm);\n}\n\n:host {\n  --font-family: \"Roboto\", sans-serif;\n  --rpf-grey-150-50: hsl(223deg 9% 85% / 50%);\n  font-family: var(--font-family);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n:host {\n  --nav-background: var(--rpf-white);\n  --border-color: var(--rpf-grey-50);\n  --box-shadow-color: rgba(0 0 0 / 8%);\n  --dropdown-active-background-color: var(--rpf-grey-100);\n  --dropdown-hover-background-color: var(--rpf-grey-50);\n  --menu-text-color: var(--text-color);\n}\n\n:host([theme=clear]) {\n  --dropdown-active-background-color: var(--transparent-black-200);\n  --dropdown-hover-background-color: var(--transparent-black-100);\n  --menu-text-color: var(--rpf-text-primary);\n}\n\n:host([theme=dark]) {\n  --dropdown-active-background-color: var(--rpf-grey-600);\n  --dropdown-hover-background-color: var(--rpf-grey-700);\n  --nav-background: var(--rpf-grey-850);\n  --text-color: var(--rpf-text-primary-darkmode);\n  --border-color: var(--rpf-grey-900);\n  --box-shadow-color: var(--rpf-grey-900);\n  --menu-text-color: var(--text-color);\n}\n\n.rpf-dropdown {\n  padding-inline: var(--space-1);\n}\n@container (min-width: 22.5rem) {\n  .rpf-dropdown {\n    position: relative;\n  }\n}\n.rpf-dropdown__button {\n  align-items: center;\n  background-color: transparent;\n  block-size: 2rem;\n  border: none;\n  border-radius: var(--border-radius);\n  box-sizing: border-box;\n  color: var(--text-color);\n  cursor: pointer;\n  display: flex;\n  inline-size: 2rem;\n  justify-content: center;\n  padding: var(--space-1);\n  position: relative;\n}\n.rpf-dropdown__button::after {\n  content: \"\";\n  inset: -0.375rem;\n  position: absolute;\n}\n@container (min-width: 22.5rem) {\n  .rpf-dropdown__button {\n    inline-size: inherit;\n  }\n  .rpf-dropdown__button::after {\n    content: \"\";\n    inset-block: -0.375rem;\n    inset-inline: 0;\n    position: absolute;\n  }\n}\n.rpf-dropdown__button:hover {\n  background-color: var(--dropdown-hover-background-color);\n}\n.rpf-dropdown__button:focus-visible {\n  background-color: transparent;\n  outline: var(--border-width-md) solid var(--focus-border-color);\n}\n.rpf-dropdown__button:active {\n  background-color: var(--dropdown-active-background-color);\n}\n.rpf-dropdown__button--selected {\n  background-color: var(--dropdown-active-background-color);\n}\n.rpf-dropdown__menu {\n  background-color: var(--nav-background);\n  border: var(--border-width-sm) solid var(--border-color);\n  border-radius: var(--border-radius);\n  box-shadow: 0 0 var(--space-1) 0 var(--box-shadow-color);\n  box-sizing: content-box;\n  color: var(--menu-text-color);\n  display: none;\n  inset-block-start: calc(100% + var(--space-1));\n  inset-inline: 0;\n  margin-inline: var(--space-1);\n  max-block-size: min(370px, 50vh);\n  overflow: hidden;\n  position: absolute;\n}\n.rpf-dropdown__menu--visible {\n  display: flex;\n}\n@container (min-width: 22.5rem) {\n  .rpf-dropdown__menu {\n    inline-size: max-content;\n    inset-block-start: calc(100% + var(--space-2));\n    inset-inline-end: unset;\n    margin-inline: unset;\n    max-inline-size: 15rem;\n    min-inline-size: 9.375rem;\n  }\n  .rpf-dropdown__menu--align-end {\n    inset-inline-end: 0;\n  }\n  .rpf-dropdown__menu--align-start {\n    inset-inline-start: 50%;\n    transform: translateX(-67%);\n  }\n  .rpf-dropdown__menu--align-center {\n    inset-inline-start: 50%;\n    transform: translateX(-50%);\n  }\n}";
const RpfDropdownStyle0 = rpfDropdownCss;

const RpfDropdown = /*@__PURE__*/ proxyCustomElement(class RpfDropdown extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.isOpenChange = createEvent(this, "isOpenChange", 7);
        this.locale = 'en-GB';
        this.alignMenu = 'start';
        this.selected = '';
        this.isOpen = false;
    }
    isOpenChangeHandler() {
        this.isOpenChange.emit({ isOpen: this.isOpen });
    }
    openWithAlphabeticKey(char) {
        this.isOpenChange.emit({ isOpen: this.isOpen, char });
    }
    handleClick(ev) {
        if (ev.composedPath().includes(this.hostElement)) {
            this.isOpen = !this.isOpen;
        }
        else {
            this.isOpen = false;
        }
        this.isOpenChangeHandler();
    }
    handleKeyDown(evt) {
        const { key, altKey } = evt;
        const openKeys = ['ArrowDown', 'ArrowUp'];
        if (key === 'Escape' || (key === 'ArrowUp' && altKey)) {
            this.isOpen = false;
            this.isOpenChangeHandler();
        }
        else if (!this.isOpen && openKeys.includes(key)) {
            this.isOpen = true;
            this.isOpenChangeHandler();
        }
        else if (!this.isOpen && isAlphabeticKey(key)) {
            evt.stopPropagation();
            this.isOpen = true;
            this.openWithAlphabeticKey(key);
        }
    }
    handleFocusOut(ev) {
        if (!this.hostElement.contains(ev.relatedTarget)) {
            this.isOpen = false;
        }
    }
    async componentWillRender() {
        this.dropdownStrings = getLocalizedStrings(this.locale, rpfDropdownStrings);
    }
    render() {
        return (h(Host, { key: 'dbf4fc670e7a1da9ee5a331970f33f3624485bf6' }, h("div", { key: 'c180d3cadc670c5ee8a552b664127ae51dc95096', class: "rpf-dropdown" }, h("button", { key: '8a594abc50ed8907b4a3567e55675baf8c3a8d06', class: `rpf-dropdown__button ${this.isOpen ? 'rpf-dropdown__button--selected' : ''}`, "aria-controls": this.listBoxId, "aria-expanded": this.isOpen ? 'true' : 'false', "aria-haspopup": "listbox", "aria-activedescendant": this.isOpen ? this.selected : '', role: "combobox", "aria-labelledby": "button", title: this.dropdownStrings['toggle_menu_title'] }, h("slot", { key: '5111119eb7618b801c051cf51ace10b9973372c2', name: "button" }, "OPEN MENU")), h("div", { key: '251f4f161696c8ac04de1305e36f498c1d2d091e', class: `rpf-dropdown__menu rpf-dropdown__menu--align-${this.alignMenu} ${this.isOpen ? 'rpf-dropdown__menu--visible' : ''}`, role: "listbox", id: this.listBoxId }, h("slot", { key: '7c6977f1f76c6fe55fca9798529b448715dfcb61' })))));
    }
    get hostElement() { return this; }
    static get style() { return RpfDropdownStyle0; }
}, [1, "rpf-dropdown", {
        "locale": [1],
        "alignMenu": [1, "align-menu"],
        "theme": [513],
        "selected": [1],
        "listBoxId": [1, "list-box-id"],
        "isOpen": [32]
    }, [[8, "click", "handleClick"], [0, "keydown", "handleKeyDown"], [0, "focusout", "handleFocusOut"]]]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["rpf-dropdown"];
    components.forEach(tagName => { switch (tagName) {
        case "rpf-dropdown":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RpfDropdown);
            }
            break;
    } });
}

export { RpfDropdown as R, isAlphabeticKey as a, defineCustomElement as d, getLocalizedStrings as g, injectFont as i };

//# sourceMappingURL=rpf-dropdown2.js.map